import { get } from "../../utils/request";

export const getFullProducts = async () => {
  const res = await get("products");
  return res;
};
